import { render, staticRenderFns } from "./GerenciaCadastroQhRecessos.vue?vue&type=template&id=bdd198b0&scoped=true"
import script from "./GerenciaCadastroQhRecessos.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroQhRecessos.vue?vue&type=script&lang=js"
import style0 from "./GerenciaCadastroQhRecessos.vue?vue&type=style&index=0&id=bdd198b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd198b0",
  null
  
)

export default component.exports